import React from 'react';
import {AbstractNumberField} from "./AbstractNumberField";
import type {AbstractNumberFieldProps} from "./AbstractNumberField";

export const NumberField: React.FC<AbstractNumberFieldProps> = (props) => {
	return <AbstractNumberField
		{...props}
	/>;
};
